import { __module as p } from "./chunk760.js";
import { __require as N } from "./chunk648.js";
var T = p.exports, b;
function G() {
  return b ? p.exports : (b = 1, function(C, $) {
    (function(q, h) {
      C.exports = h(N());
    })(T, function(q) {
      return function(h) {
        var l = q, B = l.lib, P = B.WordArray, _ = B.Hasher, x = l.algo, w = [], S = [];
        (function() {
          function s(t) {
            for (var i = h.sqrt(t), u = 2; u <= i; u++)
              if (!(t % u))
                return !1;
            return !0;
          }
          function n(t) {
            return (t - (t | 0)) * 4294967296 | 0;
          }
          for (var r = 2, e = 0; e < 64; )
            s(r) && (e < 8 && (w[e] = n(h.pow(r, 1 / 2))), S[e] = n(h.pow(r, 1 / 3)), e++), r++;
        })();
        var v = [], y = x.SHA256 = _.extend({
          _doReset: function() {
            this._hash = new P.init(w.slice(0));
          },
          _doProcessBlock: function(s, n) {
            for (var r = this._hash.words, e = r[0], t = r[1], i = r[2], u = r[3], o = r[4], d = r[5], H = r[6], A = r[7], a = 0; a < 64; a++) {
              if (a < 16)
                v[a] = s[n + a] | 0;
              else {
                var c = v[a - 15], F = (c << 25 | c >>> 7) ^ (c << 14 | c >>> 18) ^ c >>> 3, f = v[a - 2], R = (f << 15 | f >>> 17) ^ (f << 13 | f >>> 19) ^ f >>> 10;
                v[a] = F + v[a - 7] + R + v[a - 16];
              }
              var k = o & d ^ ~o & H, z = e & t ^ e & i ^ t & i, D = (e << 30 | e >>> 2) ^ (e << 19 | e >>> 13) ^ (e << 10 | e >>> 22), K = (o << 26 | o >>> 6) ^ (o << 21 | o >>> 11) ^ (o << 7 | o >>> 25), W = A + K + k + S[a] + v[a], L = D + z;
              A = H, H = d, d = o, o = u + W | 0, u = i, i = t, t = e, e = W + L | 0;
            }
            r[0] = r[0] + e | 0, r[1] = r[1] + t | 0, r[2] = r[2] + i | 0, r[3] = r[3] + u | 0, r[4] = r[4] + o | 0, r[5] = r[5] + d | 0, r[6] = r[6] + H | 0, r[7] = r[7] + A | 0;
          },
          _doFinalize: function() {
            var s = this._data, n = s.words, r = this._nDataBytes * 8, e = s.sigBytes * 8;
            return n[e >>> 5] |= 128 << 24 - e % 32, n[(e + 64 >>> 9 << 4) + 14] = h.floor(r / 4294967296), n[(e + 64 >>> 9 << 4) + 15] = r, s.sigBytes = n.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var s = _.clone.call(this);
            return s._hash = this._hash.clone(), s;
          }
        });
        l.SHA256 = _._createHelper(y), l.HmacSHA256 = _._createHmacHelper(y);
      }(Math), q.SHA256;
    });
  }(p), p.exports);
}
export {
  G as __require
};
